module.exports = __webpack_public_path__ + "static/img/991B.2d2c3a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/991B/991B.png
// module id = PpYb
// module chunks = 0